import { Info } from "lucide-react";
import { isSearching } from "@/lib/searchScope";

interface SearchIgnoresFiltersHintProps {
  /** The live search term of the list. The hint renders only while it is non-blank. */
  search: string | null | undefined;
}

/**
 * Tells the user the date range and the other filters are ignored while a
 * list search is active (see `filtersUnlessSearching` in `@/lib/searchScope`).
 */
export function SearchIgnoresFiltersHint({
  search,
}: SearchIgnoresFiltersHintProps) {
  if (!isSearching(search)) return null;

  return (
    <p
      role="status"
      className="flex items-center gap-1.5 text-xs text-muted-foreground"
    >
      <Info className="h-3.5 w-3.5 shrink-0" />
      Recherche sur toutes les dates : la période et les filtres sélectionnés
      sont ignorés. Effacez la recherche pour les retrouver.
    </p>
  );
}
